import { ComponentProps } from 'react';
import { TurnaroundCard } from './TurnaroundCard';
import { Set } from 'api/models/Sets';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import { useLanguage } from 'context/AppContext';
import theme from 'App.theme';
import { TurnaroundEntity, TurnaroundPageVariant } from '../models';
import { Implant } from 'api/models/Implants';
import { TurnaroundImplants } from '../../../components/TurnaroundImplants/TurnaroundImplants';
import DeliverySetButton from 'components/SetList/components/DeliverySetButton';
import ConsolidatedSetGroup from 'components/ConsolidatedSetGroup';
import { DeliveryStatus } from 'api/models/Deliveries';

type Props = ComponentProps<'div'> & {
  variant: TurnaroundPageVariant;
  deliveryStatus?: DeliveryStatus;
  sets: Set[];
  implants: Implant[];
  selectedEntities: TurnaroundEntity[];
  isLoading?: boolean;
  onSelectSet: (setKitInstanceId: string) => void;
  onSelectImplants: () => void;
};

export const TurnaroundSelectEntities = ({
  variant,
  deliveryStatus = 'CHECKED_IN',
  sets,
  implants,
  selectedEntities,
  isLoading,
  onSelectSet,
  onSelectImplants,
  ...props
}: Props) => {
  const lang = useLanguage()[0].TurnaroundSelectEntities;

  const areImplantsSelected = selectedEntities.some(entity => entity.type === 'implant');

  return (
    <TurnaroundCard
      variant={variant}
      title={variant === 'origin' ? lang.title.origin : lang.title.destination}
      {...props}
    >
      <div
        style={{
          flex: 1,
          border: `1px solid ${theme.greys.GREYA2}`,
          borderTop: 0,
          backgroundColor: theme.colors.white,
          display: 'flex',
          flexDirection: 'column',
          gap: theme.layout.spacing.tiny,
          padding: theme.layout.spacing.tiny,
        }}
      >
        {isLoading ? (
          <PageSpinner />
        ) : (
          <>
            {/* members are only shown nested under their consolidated set and can't be moved on their own */}
            {sets
              .filter(set => !set.consolidatedIntoKitInstanceId)
              .map(set => {
                const isSetSelected = selectedEntities.some(
                  entity => entity.type === 'set' && entity.setKitInstanceId === set.kitInstanceId,
                );
                const stage = set.inspections?.CHECK_OUT
                  ? 'CHECK_OUT'
                  : set.inspections?.CHECK_IN
                  ? 'CHECK_IN'
                  : 'OUTBOUND';

                return set.consolidatedSet ? (
                  <ConsolidatedSetGroup
                    key={set.kitInstanceId}
                    stage={stage}
                    deliveryStatus={deliveryStatus}
                    consolidatedSet={set}
                    memberSets={sets.filter(s => s.consolidatedIntoKitInstanceId == set.kitInstanceId)}
                    selected={isSetSelected}
                    onClick={() => onSelectSet(set.kitInstanceId)}
                  />
                ) : (
                  <DeliverySetButton
                    key={set.kitInstanceId}
                    stage={stage}
                    deliveryStatus={deliveryStatus}
                    //supplierCreated = false,
                    sets={sets}
                    set={set}
                    editable={false}
                    selected={isSetSelected}
                    onClick={() => onSelectSet(set.kitInstanceId)}
                  />
                );
              })}

            {implants.length > 0 && (
              <TurnaroundImplants variant={variant} selected={areImplantsSelected} onClick={onSelectImplants} />
            )}
          </>
        )}
      </div>
    </TurnaroundCard>
  );
};
